import { action, makeAutoObservable, observable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import agencyMatserService from "@services/agencyMaster/agencyMasterService"

class AgencyMasterStore {
  @observable isLoading!: boolean
  @observable tradingFloors!: PagedResultDto<any>
  @observable tradingFloorDetail!: any
  @observable usersInTradingFloor!: PagedResultDto<any>
  @observable userExistsByPhone!: any
  @observable listAgencyMaster!: any[]
  @observable cartsByAgencyMaster!: PagedResultDto<any>

  constructor() {
    makeAutoObservable(this)
    this.tradingFloors = { items: [], totalCount: 0 }
    this.usersInTradingFloor = { items: [], totalCount: 0 }
    this.tradingFloorDetail = { id: null, uniqueId: null, isActive: true }
    this.userExistsByPhone = { id: 0, uniqueId: null, isActive: true }
    this.listAgencyMaster = []
    this.cartsByAgencyMaster = { items: [], totalCount: 0 }
  }

  @action
  async init() {
    this.isLoading = true
    this.tradingFloorDetail = { id: null, uniqueId: null, isActive: true }
    this.isLoading = false
  }

  @action
  async initUser() {
    this.isLoading = true
    this.userExistsByPhone = { id: 0, uniqueId: null, isActive: true }
    this.isLoading = false
  }

  @action
  async create(body: any) {
    this.isLoading = true
    const result = await agencyMatserService
      .create(body)
      .finally(() => (this.isLoading = false))
    this.tradingFloors = result
  }

  @action
  async update(body: any) {
    this.isLoading = true
    await agencyMatserService
      .update(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async get(id: number) {
    const result = await agencyMatserService.get(id)
    this.tradingFloorDetail = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await agencyMatserService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tradingFloors = result
    return result
  }

  @action
  async getAllUserByTradingFloorId(params: any) {
    this.isLoading = true
    const result = await agencyMatserService
      .getAllUserByTradingFloorId(params)
      .finally(() => (this.isLoading = false))
    this.usersInTradingFloor = result
    return result
  }

  @action
  async getExistPhone(phone: string) {
    const result = await agencyMatserService.getExistPhone(phone)
    this.userExistsByPhone = result
  }

  @action
  async assignUser(body: any) {
    this.isLoading = true
    await agencyMatserService
      .assignUser(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async getListAgencyMaster(params: any) {
    this.isLoading = true
    const result = await agencyMatserService
      .getListAgencyMaster(params)
      .finally(() => (this.isLoading = false))
    this.listAgencyMaster = result
    return result
  }

  @action
  async getAllCartByAgencyMaster(params: any) {
    this.isLoading = true
    const result = await agencyMatserService
      .getAllCartByAgencyMaster(params)
      .finally(() => (this.isLoading = false))
    this.cartsByAgencyMaster = result
    return result
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await agencyMatserService.activateOrDeactivate(id, isActive)
  }

  @action
  async importAgencyMaster(file: File) {
    this.isLoading = true
    const result = await agencyMatserService
      .ImportAgencyMaster(file)
      .finally(() => (this.isLoading = false))
    return result
  }

  @action
  async exportTemplateAgencyMaster() {
    this.isLoading = true
    await agencyMatserService
      .exportTemplateAgencyMaster()
      .finally(() => (this.isLoading = false))
  }

  @action
  async importAgencyMasterUser(file: File, agencyMasterId?: number) {
    this.isLoading = true
    const result = await agencyMatserService
      .importAgencyMasterUser(file, agencyMasterId)
      .finally(() => (this.isLoading = false))
    return result
  }

  @action
  async exportTemplateAgencyMasterUser() {
    this.isLoading = true
    await agencyMatserService
      .exportTemplateAgencyMasterUser()
      .finally(() => (this.isLoading = false))
  }
}

export default AgencyMasterStore
